import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { InfoIconGray } from "../../../../constant/imagePath";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { BookALessonCardWithGalleryMobile } from "../../../../stories/BookALessonWithGalleryMobile/BookALessonWithGalleryMobile";
import { Button } from "../../../../stories/Button/Button";
import { Checkbox } from "../../../../stories/Checkbox/Checkbox";
import { CoachDetailAboutMe } from "../../../../stories/CoachDetailAboutMe/CoachDetailAboutMe";
import { CoachDetailsCertificates } from "../../../../stories/CoachDetailCertificates/CoachDetailsCertificates";
import { CoachDetailsTrainingLocations } from "../../../../stories/CoachDetailTrainingLocations/CoachDetailsTrainingLocations";
import { CommonQuestions } from "../../../../stories/CommonQuestions/CommonQuestions";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import classes from "./CoachDetailsPreviewProfileMobile.module.css";

export default function CoachDetailsPreviewProfileMobile() {
  const [confirmProfile, setConfirmProfile] = useState([]);
  const [isCongrats, setIsCongrats] = useState(false);
  const history = useHistory()
  return (
    <div className={classes.profilePreview}>
      {/* Top Popup */}
      <div className={classes.popup}>
        <h4
          style={{
            ...Fonts.h4,
            color: Colors.neutralShadesOfNero,
            fontSize: "20px",
            lineHeight: "28px",
          }}
        >
          Preview how your profile looks to students
        </h4>
        <Checkbox
          value={confirmProfile}
          setValue={setConfirmProfile}
          label="I confirm that my profile information is accurate"
        />
      </div>
      <Container fluid className="p-0">
        <Row className="g-0">
          <Col sm={12}>
            <BookALessonCardWithGalleryMobile />
          </Col>
          <Col sm={12} className={classes.padding}>
            <CoachDetailAboutMe />
          </Col>
          <Col sm={12} className={classes.padding}>
            <CommonQuestions
              data={[
                { title: "Credentials and Experience", description: "" },
                { title: "Session plan", description: "" },
              ]}
            />
          </Col>
          <Col
            sm={12}
            className={`${[classes.padding, classes.mt48].join(" ")}`}
          >
            <CoachDetailsCertificates />
          </Col>
          <Col
            sm={12}
            className={`${[classes.padding, classes.mt48].join(" ")}`}
          >
            <CoachDetailsTrainingLocations />
          </Col>

          <Col
            sm={12}
            className={`${[classes.padding, classes.mt48, classes.mb48].join(
              " "
            )}`}
          >
            <CommonQuestions heading="Common Questions" />
          </Col>
          <Col sm={12} className={`${[classes.padding].join(" ")}`}>
            <div className={classes.bottomAlert}>
              <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
                You can continue to edit your profile once your account is
                established.
              </p>
              <img src={InfoIconGray} />
            </div>
          </Col>
          <Col sm={12}>
            {/* Buttons Box */}
            <div
              className={classes.btnsBox}
              style={{
                borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
            >
              <LinkButtonWithIcon
                text={"Back to Edit"}
                primary={false}
                customStyle={{ color: Colors.neutralShadesOfNero }}
                onClick={() => history.push('/all-steps')}
              />
              <Button
                disabled={confirmProfile?.length == 0 ? true : false}
                label={"Finish"}
                primary={true}
                size={"Large"}
                customStyle={{ width: "156px", height: "56px" }}
                onClick={() => {
                  setIsCongrats(true)
                  history.push('/todo')

                }}
              />
            </div>
          </Col>
        </Row>
      </Container>

    </div>
  );
}
